import { API, graphqlOperation, Storage } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import ToolDocumentForm from "components/tools/documents/ToolDocumentForm";
import { updateToolDocument } from "graphql/mutations";
import { getToolDocument } from "graphql/queries";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const ToolDocumentUpdateForm = ({ toolDocumentId, onSuccess }) => {
  const navigate = useNavigate();
  const [toolDocument, setToolDocument] = useState();
  const [loading, setLoading] = useState(false);

  async function onSubmit(valuesParam) {
    try {
      setLoading(true);

      const { fileName, fileSrc: fileObj } = valuesParam;
      let fileSrc = toolDocument.fileSrc;

      if (fileObj !== toolDocument.fileSrc) {
        fileSrc = `${fileObj.name
          .split(".")
          .slice(0, -1)
          .join(".")}_${Date.now()}.${fileObj.name.split(".").slice(-1)[0]}`;

        await Storage.put(`tools/${fileSrc}`, fileObj, {
          contentType: fileObj.type,
          level: "public",
        });

        await Storage.remove(`tools/${toolDocument.fileSrc}`, {
          level: "public",
        });
      }

      await API.graphql({
        query: updateToolDocument.replaceAll("__typename", ""),
        variables: {
          input: {
            id: toolDocumentId,
            fileName,
            fileSrc,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/tools");
    } catch (err) {
      toast.error(strings.responses[err]);
    } finally {
      setLoading(false);
    }
  }

  async function fetchToolDocument(id) {
    try {
      const toolDocumentData = await API.graphql(
        graphqlOperation(getToolDocument, { id })
      );
      const toolDocumentItem =
        toolDocumentData.data.getToolDocument;
      if (!toolDocumentItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/tools");
        return;
      }
      setToolDocument({
        ...toolDocumentItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchToolDocument(toolDocumentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toolDocumentId]);

  if (!toolDocument) return <Loader />;

  return (
    <div>
      <ToolDocumentForm
        onSubmit={onSubmit}
        type="update"
        initialValues={toolDocument}
      />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Documento de Herramienta",
    successUpdated: "Documento de Herramienta actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el documento de herramienta",
    },
  },
});

export default ToolDocumentUpdateForm;
